import type { AnimationDebugState } from '../AnimationController';
import { RecordingManager } from './RecordingManager';

export type RecordFrameParams = {
  characterId: string;
  debugState: AnimationDebugState;
  currentState: string;
  currentPhase?: string | null;
};

export class RecordingManagerStore {
  private static instance: RecordingManagerStore | null = null;

  private readonly recordingManager: RecordingManager;

  private constructor() {
    this.recordingManager = new RecordingManager();
  }

  static getInstance(): RecordingManagerStore {
    if (!RecordingManagerStore.instance) {
      RecordingManagerStore.instance = new RecordingManagerStore();
    }
    return RecordingManagerStore.instance;
  }

  getRecordingManager(): RecordingManager {
    return this.recordingManager;
  }

  /**
   * Ensures recording is active without re-starting (and wiping) an active session.
   */
  ensureStarted(characterId: string): void {
    if (this.recordingManager.getState() === 'idle') {
      this.recordingManager.start(characterId);
    }
  }

  /**
   * Records a frame from the game loop. This is intended to be called every render frame.
   */
  recordFrame(params: RecordFrameParams): void {
    this.ensureStarted(params.characterId);
    this.recordingManager.addFrame(params.debugState, params.currentState, params.currentPhase ?? null);
  }
}

export const recordingManagerStore = RecordingManagerStore.getInstance();
